import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

const Icon1 = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
            <rect opacity="0.01" width="60" height="60" fill="#33AE44" />
            <path
                d="M16.25 25H27.4219M16.25 37.0802H27.4219M32.5781 25H43.75M16.25 31.2034H27.4219M32.5781 37.5V32.0238C32.5781 31.5707 32.9629 31.2034 33.4375 31.2034H43.75"
                stroke="#33AE44"
                strokeWidth="3"
                strokeLinecap="round"
            />
            <circle cx="30" cy="30" r="22.5" stroke="#33AE44" strokeWidth="3" />
        </svg>
    );
};

const Icon2 = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
            <rect opacity="0.01" width="60" height="60" fill="#33AE44" />
            <path
                d="M26.1454 10.9842C28.6184 9.68027 31.3816 9.68027 33.8546 10.9842L52.9998 21.079L33.8546 31.1738C31.3816 32.4777 28.6184 32.4777 26.1454 31.1738L7.0002 21.079L26.1454 10.9842Z"
                stroke="#33AE44"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M52.9998 29.9413L33.8546 40.0361C31.3816 41.34 28.6184 41.34 26.1454 40.0361L7.0002 29.9413"
                stroke="#33AE44"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M52.9998 38.8031L33.8546 48.8979C31.3816 50.2019 28.6184 50.2019 26.1454 48.8979L7.0002 38.8031"
                stroke="#33AE44"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

const Icon3 = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
            <rect opacity="0.01" width="60" height="60" fill="#33AE44" />
            <path
                d="M46.9273 35.4952L32.3912 50.0313C31.3441 51.0784 29.6464 51.0784 28.5992 50.0313L10.9032 32.3352C6.3656 27.7976 6.3656 20.4408 10.9032 15.9032C15.4408 11.3656 22.7976 11.3656 27.3352 15.9032L30.4802 19.0481"
                stroke="#33AE44"
                strokeWidth="3"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M50.1128 16.1219C54.5294 20.5384 54.6006 27.6548 50.3265 32.1584L50.0247 32.4649L46.9265 35.497L39.656 28.2265C39.3079 27.8784 38.7439 27.8773 38.3945 28.224L35.0447 31.547C32.8431 33.7311 29.2899 33.724 27.097 31.5311L26.7969 31.231C24.514 28.9481 24.4609 25.2796 26.6377 22.9322L26.8308 22.7332L33.6155 16.056C38.1998 11.5443 45.5647 11.5737 50.1128 16.1219Z"
                stroke="#33AE44"
                strokeWidth="3"
            />
            <path
                d="M22.3418 19.7578C20.2475 17.6636 16.8521 17.6636 14.7578 19.7578C12.6635 21.8521 12.6635 25.2476 14.7578 27.3418"
                stroke="#33AE44"
                strokeWidth="3"
                strokeLinecap="round"
            />
        </svg>
    );
};

const Icon4 = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
            <rect opacity="0.01" width="60" height="60" fill="#33AE44" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M47.1412 13.4034C36.0421 13.4034 31.1446 8.66921 31.1048 8.62909L30 7.5L28.8838 8.62909C28.8383 8.68067 24.0433 13.4034 12.8531 13.4034C12.4317 13.4034 11.9989 13.3976 11.5604 13.3804L10 13.3288L10 32.2223C10 37.8391 12.0159 46.035 29.4533 52.3051L30 52.5L30.5467 52.3051C47.9841 46.035 50 37.8391 50 32.2223V13.3288L48.4339 13.3804C47.9954 13.3976 47.5626 13.4034 47.1412 13.4034Z"
                stroke="#33AE44"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M20 30.3571L26.25 37.5L40 22.5" stroke="#33AE44" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default function F() {
    const { useLang } = useGlobal();
    const { t } = useLang('powerstreamcooperation');

    return (
        <div className={`powerstream-cooperation-F ${css['powerstream-cooperation-F']}`}>
            <p className="title">{t('secF_title')}</p>
            <div className="text-wrapper">
                <div className="text-box">
                    <Icon1 />
                    <p className="title">{t('secF_title1')}</p>
                    <p className="desc">{t('secF_desc1')}</p>
                </div>
                <div className="text-box">
                    <Icon2 />
                    <p className="title">{t('secF_title2')}</p>
                    <p className="desc">{t('secF_desc2')}</p>
                </div>
                <div className="text-box">
                    <Icon3 />
                    <p className="title">{t('secF_title3')}</p>
                    <p className="desc">{t('secF_desc3')}</p>
                </div>
                <div className="text-box">
                    <Icon4 />
                    <p className="title">{t('secF_title4')}</p>
                    <p className="desc">{t('secF_desc4')}</p>
                </div>
            </div>
        </div>
    );
}
